module.exports = __webpack_public_path__ + "static/media/9-custom-cut-passepartout-board-for-ikea-SILVERHOJDEN-frame-(36in-x-27in-(91cm-x-61cm).0040d586.png";